import React, { memo } from "react";

const TABS = ["RC", "Insurance", "Permit"];

const HistoryTabs = ({ activeTab, onChange }) => {
  return (
    <div className="d-flex gap-2 mb-3">
      {TABS.map((tab) => {
        const isActive = activeTab === tab;
        return (
          <button
            key={tab}
            type="button"
            onClick={() => onChange(tab)}
            style={{
              padding: "8px 16px",
              borderRadius: "999px",
              border: isActive ? "1px solid transparent" : "1px solid #E5E7EB",
              background: isActive ? "#F2E8FF" : "#FFFFFF",
              color: isActive ? "#6D28D9" : "#4B5563",
              fontSize: "14px",
              fontWeight: 500,
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            {tab} History
          </button>
        );
      })}
    </div>
  );
};

export default memo(HistoryTabs);
